import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { User } from '../models/core.model';

@Injectable({
  providedIn: 'root'
})
export class HttpWeedfreeService {

  constructor(private http: HttpClient) { }

  operatorList(): Observable<User[]> {
    return this.http.get<User[]>(environment.baseUrl + 'weedfree/client/weedfree-users');
  }

  deleteClientDocument(client: number, document: string): Observable<boolean> {
    const postData = { client: client, document: document };

    return this.http.post<boolean>(environment.baseUrl + 'weedfree/documents/delete', postData);
  }

  uploadClientDocument(client: number, document: File) {

    let formData = new FormData();

    formData.append('client', String(client));
    formData.append('files[]', document, document.name);

    return this.http.post(
      environment.baseUrl + 'weedfree/documents/add',
      formData,
      {
        reportProgress: true,
        observe: 'events'
      }).pipe(map((event) => {

        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100 * event.loaded / event.total);
            return { status: 'progress', message: progress };

          case HttpEventType.Response:
            return { status: 'complete', message: event.body };

          default:
            return { status: 'error', message: 'Unhandled event: ' + event.type };
        }

      }));
  }
}
